import {BehaviorSubject, merge, of} from 'rxjs';
import {filter, share, switchMap, tap, timeout, catchError} from 'rxjs/operators';
import {track} from '@/et';
import {toWsMsg$, wsStatus$} from '@/ws';
import {toUiMsg$} from '@/ui';
import {logout$, userToken$} from './auth';
import type {ws} from '@/types';

const auth$ = wsStatus$.pipe(
  filter((wsStatus) => wsStatus === 'Opened'),
  switchMap(() => userToken$),
  filter((o) => !!o.token),
  switchMap(({token, platform = 'PC'}) =>
    toWsMsg$
      .send({method: 'user.auth', params: [platform, token]})
      .pipe(
        // auth 订阅有时候会出现没有拿到返回的现象
        timeout(5e3),
        catchError((error) => {
          if (error.name === 'TimeoutError') {
            return of({error: 'auth timeout'});
          }
          throw error;
        }),
      )
  ),
  tap((o) => track('user_auth', o)),
  tap(o => {
    // 超时直接刷新页面，避免 public 和 auth 状态不一致
    // http://confluence.cmexpro.com/pages/viewpage.action?pageId=91034923
    if (o.error === 'auth timeout') {
      toUiMsg$.next({type: 'auth-timeout', error: o.error});
    }
  }),
  share()
);

const authFail$ = auth$.pipe(
  filter((o) => o.error),
  tap((o) => {
    toUiMsg$.next({type: 'auth-error', error: o.error});
    console.warn('user.auth error:', o.error);
  }),
  share()
);

export const wsLogin$ = auth$.pipe(filter((o) => !o.error));
export const wsLogout$ = merge<[ws.Msg, ws.Msg]>(authFail$, logout$);

export const isWsLogin$ = new BehaviorSubject<boolean>(false);

wsLogin$.subscribe(() => isWsLogin$.next(true));
wsLogout$.subscribe(() => isWsLogin$.next(false));
